import { render, staticRenderFns } from "./StaffManagement.vue?vue&type=template&id=256f51d0&scoped=true&"
import script from "./StaffManagement.vue?vue&type=script&lang=js&"
export * from "./StaffManagement.vue?vue&type=script&lang=js&"
import style0 from "./StaffManagement.vue?vue&type=style&index=0&id=256f51d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f51d0",
  null
  
)

export default component.exports